import { render, staticRenderFns } from "./PersistNntTagView.vue?vue&type=template&id=da2ccb68"
import script from "./PersistNntTagView.vue?vue&type=script&lang=ts"
export * from "./PersistNntTagView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports